import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchMinis, fetchMiniDownloadCSV  } from '../actions/minis'

import MiniList from '../components/MiniList'
import ErrorMessage from '../components/ErrorMessage'
import '../styles/MachinesAdminView.css'

class MinisView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      
    }

    this.handleMiniDownloadCSV = this.handleMiniDownloadCSV.bind(this)
  }

  componentDidMount() {
    this.props.fetchMinis()
  }

  handleMiniDownloadCSV() {
    const { fetchMiniDownloadCSV } = this.props

    fetchMiniDownloadCSV();
  }

  render() {
    const { minis, error, role } = this.props

    return (
      <div className="machines-admin-view">
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-tablet-alt mr-3"></i>
                <span className="text-vw-dark mr-1">Parque de</span>
                <span className="text-vw-light">Minis</span>
              </h1>
            </div>
            {role === 'ADMIN' && (
              <div className="header-actions">
                <Link to="/minis/add" className="mach-admin-btn primary">
                  <i className="fas fa-plus"></i>
                  <span>Nueva Mini</span>
                </Link>
                <button className="mach-admin-btn success" onClick={this.handleMiniDownloadCSV}>
                  <i className="fas fa-file-excel"></i>
                  <span>Descargar Listado</span>
                </button>
              </div>
            )}
          </div>
        </div>
        <MiniList minis={minis} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  minis: state.minis.minis,
  error: state.minis.error,
  role: state.auth.role
})

const mapDispatchToProps = dispatch => ({
  fetchMinis: bindActionCreators(fetchMinis, dispatch),
  fetchMiniDownloadCSV: bindActionCreators(fetchMiniDownloadCSV, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(MinisView)
